import React from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import ProgressBar from "../../components/ProgressBar";
import LearningPathCardImage from "./LearningPathCardImage";
import { useTranslation } from "react-i18next";

export default function LearningPathCard(props) {
  const {
    title,
    image,
    id,
    ProgressBarPercentage,
    ProgressBarWidth,
    coursesCounts,
    completedCoursesCount,
    subscribedAt,
    completeBy,
    remainingDays,
    learningTrackPageUrl,
    buttonText,
    buttonType,
    buttonIcon,
    backGroundColor,
    boxShadow,
    isAdmin,
    isArchived,
  } = props;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation(["common", "learningPaths"]);

  function openDetails(e) {
    if (!isArchived)
      navigate(
        isAdmin
          ? `/admin/learning_paths/${id}`
          : `/employee/learning_paths/${id}`,
      );
  }

  const formatCardDate = (value) => {
    if (!value) return "";
    const parsed = moment(
      value,
      ["DD / MM / YYYY", "D / M / YYYY", "DD/MM/YYYY", moment.ISO_8601],
      true,
    );
    const date = parsed.isValid() ? parsed : moment(value);
    if (!date.isValid()) return value;
    return date.locale(i18n.language).format("DD MMM YYYY");
  };

  const deadlineDate = formatCardDate(completeBy);
  const subscribedDateLabel = formatCardDate(subscribedAt);
  const deadlineStatus =
    remainingDays > 0
      ? t("learningPaths:remainingTime", { days: remainingDays })
      : t("learningPaths:deadlinePassed", {
          lateDays: Math.abs(remainingDays),
        });

  return (
    <div
      onClick={openDetails}
      className="card-style learinig-path-card"
      style={{
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        opacity: isArchived ? "0.5" : "1",
      }}
    >
      <LearningPathCardImage src={image} alt={title} />

      <div className="learinig-path-card__content">
        <h2 className="card-title">{title}</h2>
        <ProgressBar
          width={ProgressBarWidth}
          percentageText={ProgressBarPercentage}
        />
        <div className="card-detail">
          <p className="card-detail__line mb-0">
            {t("learningPaths:completedCoursesSummary", {
              completed: completedCoursesCount || 0,
            })}
          </p>
          <p className="card-detail__line mb-0">
            {t("learningPaths:totalCoursesSummary", {
              total: coursesCounts || 0,
            })}
          </p>
          {subscribedDateLabel ? (
            <p className="card-detail__line mb-0">
              {t("learningPaths:subscribedAt")}
              {subscribedDateLabel}
            </p>
          ) : null}
          {completeBy ? (
            <p className="card-detail__line mb-0">
              {t("learningPaths:learningPathsDeadline", { date: deadlineDate })}{" "}
              {deadlineStatus}
            </p>
          ) : null}
        </div>
      </div>

      {learningTrackPageUrl && (
        <div className="learinig-path-card__btn">
          <Link
            className={`btn btn-course ${buttonType}-course`}
            to={learningTrackPageUrl}
            onClick={(e) => e.stopPropagation()}
          >
            {buttonText}
            {buttonIcon && (
              <span className="fas fa-arrow-right fa-fw ms-2"></span>
            )}
          </Link>
        </div>
      )}
    </div>
  );
}
